import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'
import StageGroupService from '@forwardflow/services/StageMapping'
import { PaginationQueryParams } from '@forwardflow/types'
import useSWR from 'swr'

export function useGetFubStages(queryParams: PaginationQueryParams) {
   const response = useSWR([QUERY_KEYS.GET_FUB_LEADS, { ...queryParams }], () =>
      StageGroupService.getFubStages(queryParams)
   )
   return {
      ...response,
   }
}
